import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TSystemParameter {
  id: number;
  path: string;
  description: string;
  parameterType: string;
  valueVchar?: string;
  valueNumber?: number;
  valueInteger?: number;
  valueDateTime?: Date;
  valueClob?: string;
  valueBoolean?: boolean;
}
export interface ISystemParameter extends TSystemParameter {}
const SystemParameter = Model(
  (model: TSystemParameter): ISystemParameter => {
    const _systemParameter: TSystemParameter = Object.assign({}, model);

    let create = (systemParameter: ISystemParameter): ISystemParameter => {
      let obj = ValidatableObject(systemParameter);
      return obj;
    };

    let systemParameter = {
      get id() {
        return _systemParameter.id;
      },
      set id(value) {
        _systemParameter.id = value;
      },

      get path() {
        return _systemParameter.path;
      },
      set path(value) {
        _systemParameter.path = value;
      },

      get description() {
        return _systemParameter.description;
      },
      set description(value) {
        _systemParameter.description = value;
      },

      get parameterType() {
        return _systemParameter.parameterType;
      },
      set parameterType(value) {
        _systemParameter.parameterType = value;
      },

      get valueVchar() {
        return _systemParameter.valueVchar;
      },
      set valueVchar(value) {
        _systemParameter.valueVchar = value;
      },

      get valueNumber() {
        return _systemParameter.valueNumber;
      },
      set valueNumber(value) {
        _systemParameter.valueNumber = value;
      },

      get valueInteger() {
        return _systemParameter.valueInteger;
      },
      set valueInteger(value) {
        _systemParameter.valueInteger = value;
      },

      get valueDateTime() {
        return _systemParameter.valueDateTime;
      },
      set valueDateTime(value) {
        _systemParameter.valueDateTime = value;
      },

      get valueClob() {
        return _systemParameter.valueClob;
      },
      set valueClob(value) {
        _systemParameter.valueClob = value;
      },

      get valueBoolean() {
        return _systemParameter.valueBoolean;
      },
      set valueBoolean(value) {
        _systemParameter.valueBoolean = value;
      }
    };
    return create(systemParameter);
  }
);

export default SystemParameter;
